export default __webpack_public_path__ + "static/media/detalii_apartament_48-min.744c455a.jpg";